var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3.8 -1.5 40.921 40.921",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 271.97,
    x2: 211.104,
    y1: 217.606,
    y2: 341.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3e863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#55934f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5aad45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 186.484,
    x2: 297.349,
    y1: 321.381,
    y2: 239.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3e863d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#619857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76ac64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 197.051,
    x2: 288.72,
    y1: 279.652,
    y2: 279.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6bbf47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#79b461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#75ac64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#659e5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3e863d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m239.03 226.605-42.13 24.317a5.085 5.085 0 0 0-2.546 4.406v48.668c0 1.817.968 3.496 2.546 4.406l42.133 24.336a5.1 5.1 0 0 0 5.09 0l42.126-24.336a5.096 5.096 0 0 0 2.54-4.406v-48.668c0-1.816-.97-3.496-2.55-4.406l-42.12-24.317a5.123 5.123 0 0 0-5.1 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.398 307.086c.403.523.907.976 1.5 1.316l36.14 20.875 6.02 3.46c.9.52 1.926.74 2.934.665.336-.027.672-.09 1-.183l44.434-81.36c-.34-.37-.738-.68-1.184-.94l-27.586-15.93-14.582-8.39a5.318 5.318 0 0 0-1.32-.53zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.066 225.953a5.14 5.14 0 0 0-2.035.652l-42.01 24.247 45.3 82.51c.63-.09 1.25-.3 1.81-.624l42.13-24.336a5.105 5.105 0 0 0 2.46-3.476l-46.18-78.89a5.29 5.29 0 0 0-1.03-.102l-.42.02"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-68.564 -79.701) scale(.35278)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m331.363 246.793-118.715-58.19-60.87 124.174L270.49 370.97zm0 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(-68.564 -79.701) scale(.35278)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m144.07 264.004 83.825 113.453 110.86-81.906-83.83-113.45zm0 0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-68.564 -79.701) scale(.35278)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M197.02 225.934v107.43h91.683v-107.43zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.01defc693b98adf7afa0f02417db9811.svg";
export { ForwardRef as ReactComponent };